import { render } from "./local.vue?vue&type=template&id=9d9cdf6c"
import script from "./local.vue?vue&type=script&lang=js"
export * from "./local.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__